import { Typography } from '@aloft/toolkit-sui';

import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen.tsx';
import { useGetAccount } from '../../hooks/api/schema-hooks/useGetAccount.ts';

export const AccountIDRouteElement = () => {
  const getAccount = useGetAccount({});

  if (getAccount.isLoading) {
    return <LoadingScreen what="Profile" />;
  }

  if (getAccount.isError) {
    throw Error(`Failed to load profile: ${getAccount.error as string}`);
  }

  return (
    <>
      <Typography variant="displaySmall">Account ID:</Typography>
      <Typography variant="displaySmall">{getAccount.data.id}</Typography>
    </>
  );
};
